<section class="dark-section" [attr.aria-labelledby]="headingId()">
  <div class="dark-section__container" [class.dark-section__container--narrow]="narrow()">
    <h2 [id]="headingId()" class="dark-section__title">{{ titleKey() | translate }}</h2>
    <ng-content />
  </div>
</section>
